import React from "react";
import { CodeOqt, TextOqt, TextPropertyName, WrapperComponent, useDialogNodeContext } from "../..";
import { useEffect } from "react";

const clipboardFields = ["nombre", "descripcion", "script"];

export const FormNodeProcess = ({fmk}) => {

  const { clipboard } = useDialogNodeContext();
  useEffect(()=>{
    clipboard.setCopyProps(clipboardFields);
    clipboard.setPasteProps(clipboardFields);
  }, [])

  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
      <WrapperComponent caption="Script" Field={<CodeOqt  caption="Script" name="script" formik={fmk} variant="standard" />}/>
    </>
  )
  
}